/* eslint import/prefer-default-export: ["off"] */
export const DEFINE_LOADING = 'DEFINE_LOADING';
